import { useEffect } from 'react';
import { useLocalStorage } from '../../services/hooks/useLocalStorage';
import { useLocation } from 'react-router-dom';
import { STC_ID, STRATUS_ID } from '../../services/constants';

import Header from '../Header';
import Loading from '../Loading';

const ToDipa = () => {
    const location = useLocation();
    const [sqta, _] = useLocalStorage('dipa-sqta', '');
    const [stratus, setStratus] = useLocalStorage("stratus", false);
    const [_accessToken, setAccessToken] = useLocalStorage('accessToken', undefined);
    const [_tenant, setTenant] = useLocalStorage('tenant', undefined);
    const [_client, setClient] = useLocalStorage('client', undefined);
    const [_appVersion, setAppVersion] = useLocalStorage('appVersion', '')

    useEffect(() => {
        setAccessToken(undefined);
        setTenant(undefined);
        setClient(undefined);
        const params = new URLSearchParams({
        });
        const query = new URLSearchParams(location.search);
        let appId = STC_ID;
        const isStratusPresent = query.get("stratus") !== null ? query.get("stratus") : stratus;
        if (isStratusPresent) {
            appId = STRATUS_ID;
            setStratus(true);
        } else {
            // If both STC and Stratus are installed, this will help switch between both of them
            setStratus(false);
        }
        const version = location.state?.version || query.get("version");
        if (version) {
            setAppVersion(version);
        }
        if (query.get('firstLaunch') !== null) {
            params.append('sqta', '');
        } else if (sqta && sqta.length > 0) {
            params.append('sqta', sqta);
        } else {
            params.append('sqta', '');
        }
        let queryString = params.toString();
        queryString = '?' + queryString;
        const url = `http://localhost:8090/${appId}/paragon.html${queryString}`;
        window.location = url;
    })

    return (
        <>
            <Header />
            <Loading />
        </>
    )
}

export default ToDipa;